export default { sha: '550bf831cfb923dcaa9c15c112a6d5e7f7836bda', buildNumber: 'undefined' }
